/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrHeaderSeparator } from './igr-header-separator';
import { HeaderSeparator } from './HeaderSeparator';
import { TypeRegistrar } from "igniteui-react-core";
var IgrHeaderSeparatorModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrHeaderSeparatorModule() {
    }
    IgrHeaderSeparatorModule.register = function () {
        TypeRegistrar.registerCons("IgrHeaderSeparator", IgrHeaderSeparator);
        TypeRegistrar.register("HeaderSeparator", HeaderSeparator.$type);
    };
    return IgrHeaderSeparatorModule;
}());
export { IgrHeaderSeparatorModule };
//# sourceMappingURL=igr-header-separator-module.js.map
